import { mutatorAction } from 'satcheljs';
import { getCopilotChatDrawerState, getStore } from '../store/store';

export const closeCopilotChatDrawerMutator: (targetWindow: Window) => void = mutatorAction(
    'closeCopilotChatDrawerMutator',
    (targetWindow: Window) => {
        const state = getCopilotChatDrawerState(targetWindow);
        if (!state) {
            return;
        }
        state.isShown = false;
        // Reset session-scoped fields so the next drawer open starts fresh.
        // Without this, `showInReadingPane=true` lingers and causes the next open to
        // momentarily render in reading-pane mode before reactive logic corrects it.
        state.showInReadingPane = false;
        state.disableEmptyReadingPaneFill = false;

        const store = getStore();
        store.heartbeatWorkingSetSizeMb = undefined;
        store.heartbeatCommitSizeMb = undefined;
    }
);
